import { useSpring, animated, config } from "@react-spring/web"
import React, { useEffect, useRef } from "react"

const CustomInput = ({ placeholder, labelText, as: Component, errorMessage, scrollTo, focusColor, valid = true, ...rest }) => {
    const ref = useRef()

    Component = Component || <input />

    const [styles, api] = useSpring(() => ({
        config: config.stiff,
        translateY: "-50%",
        top: rest.rows ? "20%" : "50%",
        fontSize: "15px",
        color: "#a9aaab"
    }))

    const onEnter = () => {
        scrollTo && scrollTo(ref.current.offsetTop)
        api.start({
            translateY: "-150%",
            fontSize: "10px",
            color: focusColor || "#003854"
        })
    }

    const onLeave = (e) => {
        if (!e.target.value) {
            api.start({
                translateY: "-50%",
                fontSize: "15px",
                color: "#a9aaab"
            })
        }
    }

    useEffect(() => {
        if (!rest.value && !rest.defaultValue) return;
        api.start({
            translateY: "-150%",
            fontSize: "10px",
            color: focusColor || "#003854"
        })
    }, [rest, api])

    return (
        <div>
            <div
                className='relative min-h-14 flex'
                onBlur={onLeave}
                onFocus={onEnter}
                ref={ref}
            >
                {
                    React.cloneElement(Component, {
                        className: `border rounded-md bg-transparent ${focusColor ? "text-white" : "text-skgBlue"} px-2 pt-4 min-h-14 w-full text-xl placeholder:text-transparent placeholder:font-light focus:placeholder:text-skgGray outline-none ${valid || !String(rest.value).length ? `border-skgGray  focus:border-[${focusColor}]` : "border-skgRed"}`,
                        placeholder,
                        id: placeholder,
                        ...rest
                    })
                }
                <animated.label
                    style={styles}
                    className='absolute left-2 font-light'
                    htmlFor={placeholder}
                >
                    {labelText}
                </animated.label>
            </div>
            {
                errorMessage && !valid && String(rest.value).length
                    ? (
                        <div
                            className="text-skgRed font-extralight text-xs pl-2 pt-1"
                        >
                            {errorMessage}
                        </div>
                    )
                    : null
            }
        </div>

    )
}

export default CustomInput;